import { ref } from 'vue'

export interface ConfirmOptions {
  title?: string
  message: string
  okTitle?: string
  cancelTitle?: string
  variant?: 'primary' | 'danger' | 'warning'
}

interface DialogState {
  isVisible: boolean
  options: ConfirmOptions
  resolve: ((value: boolean) => void) | null
}

const state = ref<DialogState>({
  isVisible: false,
  options: {
    title: 'Please Confirm',
    message: '',
    okTitle: 'YES',
    cancelTitle: 'NO',
    variant: 'primary',
  },
  resolve: null,
})

export function useConfirmDialog() {
  const showConfirm = (message: string, options?: Partial<ConfirmOptions>): Promise<boolean> => {
    state.value.options = {
      title: options?.title || 'Please Confirm',
      message,
      okTitle: options?.okTitle || 'YES',
      cancelTitle: options?.cancelTitle || 'NO',
      variant: options?.variant || 'primary',
    }
    state.value.isVisible = true

    return new Promise((resolve) => {
      state.value.resolve = resolve
    })
  }

  const handleOk = () => {
    state.value.isVisible = false
    if (state.value.resolve) {
      state.value.resolve(true)
      state.value.resolve = null
    }
  }

  const handleCancel = () => {
    state.value.isVisible = false
    if (state.value.resolve) {
      state.value.resolve(false)
      state.value.resolve = null
    }
  }

  return {
    state,
    showConfirm,
    handleOk,
    handleCancel,
  }
}
